import { AccountBalanceItem } from "../../components/Accounts/AccountBalanceItem";
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { allowedBalance, buttonData } from "./data";
import { Hrule } from "../../components/AddUser/AddUserContainer";
import AccountButton from "../../components/Accounts/AccountButton";
import { colors } from "../../theme/color";
import { useDispatch, useSelector } from "react-redux";
import { setFirstModalOpen } from "../../store/accountsModal";
import { RootState } from "../../store/rootReducer";
import { useQuery } from "@apollo/client";
import { getUserBankDetails } from "../../graphql/queries/accounts";

export const AccountBalanceTemplate = () => {
  const dispatch = useDispatch();
  const id = useSelector((state: RootState) => state.user?.user.id);

  const { data: queryData, refetch: refetchUserBankDetails } =
    useQuery(getUserBankDetails);

  const userBankDetails = queryData?.getUserBankDetails || "";

  const financeDetails = userBankDetails?.userFinancialDetails || {};

  const handleButtonClick = (index: number) => {
    index === 1 && dispatch(setFirstModalOpen(true));
  };

  useEffect(() => {
    refetchUserBankDetails();
  }, [id]);

  return (
    <WrapperStyle>
      <TitleText>Account Balances</TitleText>
      <Hrule />
      <InnerWrapper>
        <Heading>Checkings Account</Heading>
        <Balance>
          {allowedBalance
            .filter(({ hidden }) => !hidden)
            .map((item) => (
              <AccountBalanceItem
                title={item.title}
                amount={financeDetails[item.key] ?? 0}
                currency={item.currencyKey}
              />
            ))}
        </Balance>
        <ButtonContainer>
          {buttonData.map((button, index) => (
            <AccountButton
              key={index}
              disabled={index === buttonData.length - 1}
              onClick={() => handleButtonClick(index)}
              title={button.title}
              icon={button.icon}
            />
          ))}
        </ButtonContainer>
      </InnerWrapper>
    </WrapperStyle>
  );
};
export const Heading = styled.h3`
  display: flex;
  justify-content: center;
  @media screen and (max-width: 767px) {
    margin: 2rem 0;
  }
`;
export const TitleText = styled.p`
  font-size: 18px;
  font-weight: 500;
  line-height: 32px;
  letter-spacing: 2%;
  color: ${colors.NAVYBLUE};
  padding: 1rem 1rem 0 1rem;
`;

const Balance = styled.div`
  display: flex;
  justify-content: center;
  gap: 15px;
  > div {
    padding: 20px;
  }
  > div:not(:first-child) {
    border-left: 1px solid #e8eaed;
    @media screen and (max-width: 767px) {
      border-left: none;
    }
  }
  @media screen and (max-width: 767px) {
    flex-direction: column;
  }
`;
export const WrapperStyle = styled.div`
  background-color: ${colors.White};
  width: 78vw;
  border-radius: 10px;
  position: relative;
  margin-bottom: 2rem;
  @media screen and (max-width: 768px) {
    width: 100%;
    height: auto;
  }
`;

export const InnerWrapper = styled.div`
  padding: 0.5rem 1rem 2rem 1rem;
`;
const ButtonContainer = styled.div`
  margin-top: 3rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  justify-content: Center;
  gap: 2.5rem;
  @media screen and (max-width: 767px) {
    flex-direction: column;
  }
`;
